export default "__VITE_ASSET__DEE4EQJ$__"